import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';
import { validateEmail } from 'helpers/emails';

import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_STATUS } from '../constants';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 28px 20px 29.5px;
  background-color: var(--white);
  border-top: 1px solid var(--line-gray);
`;

const Text = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledButton = styled(Button)`
  padding: 10px 43px 10px 44px;
`;

const CompaniesCreateEditModalFooter = () => {
  const { company, handleSave, onClose } = useCompaniesCreateEditModalContext();
  const { name, primary_user_id, p_c_name, p_c_email } = company;
  const isEditMode = Boolean(company?.id);
  const onlyNameRequired = company.status === COMPANY_STATUS.OUTSIDE_COMPANY;

  const isEmailValid = validateEmail(p_c_email?.trim() || '');
  const hasValidCreatePrimaryFields = Boolean(p_c_name?.trim() && p_c_email?.trim() && isEmailValid);
  const hasValidEditPrimaryFields = Boolean(primary_user_id);

  const primaryFieldsValid = isEditMode ? hasValidEditPrimaryFields : hasValidCreatePrimaryFields;
  const disabled = !name?.trim() || (!onlyNameRequired && !primaryFieldsValid);

  return (
    <Container>
      <Text>By adding a company, a primary user will be added.</Text>
      <Actions>
        <StyledButton type="primary" onClick={handleSave} disabled={disabled}>
          Save
        </StyledButton>
        <StyledButton onClick={onClose}>Cancel</StyledButton>
      </Actions>
    </Container>
  );
};

export default CompaniesCreateEditModalFooter;
